module.exports = __webpack_public_path__ + "img/fatherhood_4.2513b97b.jpg";